import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MarketingBannerHistory } from '../../../models/marketing-banner.model';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-marketing-banner-history',
  templateUrl: './marketing-banner-history.component.html',
  styleUrls: ['./marketing-banner-history.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class MarketingBannerHistoryComponent implements OnInit {
  isLoading = true;
  loadingIcon = 'fa-circle-o-notch';
  marketingBannerHistory: MarketingBannerHistory[] = [];
  datePipe = new DatePipe('en-US');

  constructor(private osmService: OsmosisService) {}

  ngOnInit(): void {
    this.getMarketingBannerHistory(1);
  }

  getMarketingBannerHistory(programTypeId): void {
    this.isLoading = true;
    this.osmService.getMarketingnBannerHistory(programTypeId).subscribe(
      response => {
        this.isLoading = false;
        response.forEach(element => {
          element.createdOn =
            this.datePipe.transform(element.createdOn, 'yyyy-MM-dd hh:mm a') ||
            '';
        });
        this.marketingBannerHistory = response;
      },
      () => {
        this.isLoading = false;
      }
    );
  }
}
